import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { Card, Typography, Flex, Form, Input } from 'antd'
import { CheckCircleOutlined, EyeOutlined } from '@ant-design/icons'
import { htmlTemplates } from '@/components/FormBuilder/templates'
import type { FlowEditorContext } from '../../index'

const { Title, Text } = Typography

export const FormInfoPage: React.FC = () => {
  const {
    flowName,
    setFlowName,
    flowSlug,
    setFlowSlug,
    selectedTemplate,
    setSelectedTemplate,
  } = useOutletContext<FlowEditorContext>()

  return (
    <div>
      <Flex vertical gap="large" style={{ width: '100%' }}>
        <Card title="Flow Details" style={{ maxWidth: 1100 }}>
          <Form layout="vertical">
            <Form.Item label="Flow Name">
              <Input
                value={flowName}
                onChange={(e) => setFlowName(e.target.value)}
                placeholder="Enter flow name"
                size="large"
              />
            </Form.Item>
            <Form.Item label="Slug">
              <Input
                value={flowSlug}
                onChange={(e) => setFlowSlug(e.target.value)}
                placeholder="enter-flow-slug"
                size="large"
              />
            </Form.Item>
          </Form>
        </Card>

        <div style={{ paddingLeft: 24 }}>
          <Title level={5}>Choose Template</Title>
          <Text type="secondary">
            Select a pre-built template design for your lead flow.
          </Text>
        </div>

        <Flex gap={16} wrap="wrap" style={{ paddingLeft: 24 }}>
          {htmlTemplates.map((template) => {
            const isSelected = selectedTemplate === template.id
            return (
              <Card
                key={template.id}
                hoverable
                onClick={() => setSelectedTemplate(template.id)}
                style={{
                  width: 500,
                  borderColor: isSelected ? '#1890ff' : undefined,
                  borderWidth: isSelected ? 2 : 1,
                  overflow: 'hidden',
                }}
                cover={
                  <div
                    style={{
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <img
                      alt={template.name}
                      src={template.previewImage}
                      style={{
                        width: '100%',
                        height: 250,
                        objectFit: 'cover',
                        objectPosition: 'top',
                        display: 'block',
                      }}
                    />
                    <a
                      href={template.previewUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(0, 0, 0, 0.5)',
                        opacity: 0,
                        transition: 'opacity 0.3s',
                        color: '#fff',
                        fontSize: 16,
                        gap: 6,
                      }}
                      onMouseEnter={(e) => {
                        ;(e.currentTarget as HTMLElement).style.opacity = '1'
                      }}
                      onMouseLeave={(e) => {
                        ;(e.currentTarget as HTMLElement).style.opacity = '0'
                      }}
                    >
                      <EyeOutlined /> Preview
                    </a>
                    {isSelected && (
                      <div
                        style={{
                          position: 'absolute',
                          top: 8,
                          right: 8,
                          background: '#52c41a',
                          borderRadius: '50%',
                          width: 24,
                          height: 24,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <CheckCircleOutlined
                          style={{ color: '#fff', fontSize: 14 }}
                        />
                      </div>
                    )}
                  </div>
                }
              >
                <Card.Meta
                  title={<Text style={{ fontSize: 13 }}>{template.name}</Text>}
                />
              </Card>
            )
          })}
        </Flex>
      </Flex>
    </div>
  )
}
